import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import styles from './TableList.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, cellWidth, priceFenToYuanCell } from '@/components/TableCell';
import { DefaultListFeilds as df } from '../../../types';
import { TableActionType as ta } from '@/util/enum';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '支付单号',
            dataIndex: df.id,
            key: df.id,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '第三方单号',
            dataIndex: df.otherId,
            key: df.otherId,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '会员手机号',
            dataIndex: df.tel,
            key: df.tel,
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '会员昵称',
            dataIndex: df.name,
            key: df.name,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '充值金额（元）',
            dataIndex: df.rechargeAmount,
            key: df.rechargeAmount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '赠送金额（元）',
            dataIndex: df.giveAmount,
            key: df.giveAmount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '手续费（元）',
            dataIndex: df.serviceFee,
            key: df.serviceFee,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '充值来源',
            dataIndex: df.rechargeSourceDesc,
            key: df.rechargeSourceDesc,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '设备ID',
            dataIndex: df.deviceId,
            key: df.deviceId,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '充值城市',
            dataIndex: df.rechargeCity,
            key: df.rechargeCity,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '支付方式',
            dataIndex: df.payTypeDesc,
            key: df.payTypeDesc,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '支付时间',
            dataIndex: df.payTime,
            key: df.payTime,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '发票号',
            dataIndex: df.invoiceId,
            key: df.invoiceId,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '备注',
            dataIndex: df.remark,
            key: df.remark,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'key',
            width: cellWidth.normal,
            key: 'action',
            align: 'center',
            fixed: 'right',
            render: (text, item) => this._renderActionCell(item.id, item)
        }
    ]);

    _renderActionCell = (key, item) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                {!item[df.invoiceId] && <div className={styles.item} onClick={() => tableAction(key, ta.sure, item)}>开票</div>}
            </div>
        );
    }

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={df.id}
                    columns={this._takeColumns()}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableList;